import { cn } from "@/lib/utils";

import { Table, TableBody, TableCell, TableRow } from "./ui/table";

type ValidatedCell = {
  value: string;
  error?: string;
};

type ValidatedDatasetItem = {
  id: string;
  cells: ValidatedCell[];
};

type ValidatedDataset = ValidatedDatasetItem[];

type SheetTableProps = {
  sheet: ValidatedDataset;
  headers?: string[];
};

export default function SheetTable({ sheet, headers }: SheetTableProps) {
  return (
    <Table>
      <TableBody>
        {headers && (
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header} className="font-semibold border-border border bg-muted">
                {header}
              </TableCell>
            ))}
          </TableRow>
        )}
        {sheet.map((row, index) => (
          <TableRow
            key={index}
            className={cn(
              row.cells.some((cell) => cell.error) && "bg-destructive/10 hover:bg-destructive/15",
            )}
          >
            {row.cells.map((cell, index) => (
              <TableCell key={index} className="border-border border">
                {cell.value}
                {cell.error && <div className="text-xs text-destructive">{cell.error}</div>}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
